<template>
<div>
    <Navigation />
    <v-container>
        <v-card>
            <v-card-title>
                Search
            </v-card-title>
            <v-card-text>
                Search for User within this facility
            </v-card-text>
            <v-card-text>
                <v-autocomplete v-model="model" :items="items" :loading="isLoading" :search-input.sync="search" color="gray" hide-no-data hide-selected item-text="userName" item-value="API" label="Users" placeholder="Start typing to Search" prepend-icon="mdi-database-search" return-object></v-autocomplete>
            </v-card-text>
            <v-divider></v-divider>
            <!-- Use for debugging purposes ONLY!!! -->
            <!-- <v-expand-transition>
            <v-list v-if="model" class="blue-grey darken-1">
                <v-list-item
                v-for="(field, i) in fields"
                :key="i"
                >
                <v-list-item-content>
                    <v-list-item-title v-text="field.value"></v-list-item-title>
                    <v-list-item-subtitle v-text="field.key"></v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
            </v-list>
            </v-expand-transition> -->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :disabled="!model" color="grey lighten-1" @click="model = null">
                    Clear
                    <v-icon right>mdi-close-circle</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-spacer></v-spacer>

        <!-- User Notes Details -->
        <v-card v-if="model">

            <v-data-table :headers="headers" :items="notes" sort-by="appointment_date" :sort-desc="true" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title> <v-icon>mdi-notebook-multiple</v-icon> Patient Consultation Notes</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <Notes v-bind:user_id="model.user_id" 
                          action="Add new notes"
                          v-bind:appointment_date="date_now" />
                    </v-toolbar>
                  </template>

                  <template v-slot:item.actions="{ item }">
                        <Notes v-bind:id="item.id" 
                          action="Edit"
                          v-bind:user_id="model.user_id" 
                          v-bind:consultation_notes="item.consultation_notes" 
                          v-bind:actions_taken="item.actions_taken" 
                          v-bind:recommendations="item.recommendations" 
                          v-bind:medications="item.medications" 
                          v-bind:appointment_date="item.appointment_date" 
                        />
                  </template>

                  <template v-slot:item.consultation_notes="{ item }">
                        <strong>{{ formatConsulationNote(item.consultation_notes) }} </strong>
                  </template>
                  <template v-slot:item.appointment_date="{ item }">
                        {{ formatNoteDate(item.appointment_date) }}
                  </template>

            </v-data-table>
        </v-card>

    </v-container>
</div>
</template>

<script>
import Navigation from '../components/Navigation'
import Notes from '../components/Notes'
import store from '../store'

import moment from 'moment'


import {
    get_user_notes
} from '../api'

export default {

    components: {
        Navigation,
        Notes
    },

    data: () => ({
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        headers: [
          {
            text: 'Created Date',
            align: 'start',
            sortable: false,
            value: 'appointment_date',
          },
          { text: 'Consultation Notes', value: 'consultation_notes' },
          { text: 'Actions', value: 'actions', sortable: false },
      ]
    }),
    methods: {
      formatConsulationNote: function(note) {
        if(note.length > 30) note = `${note.substring(0,30)}...`
        return note
      },
      formatNoteDate: function(note_date) {
        return moment(note_date).format('lll')
      }

    },

    computed: {
        fields() {
            if (!this.model) return []

            return Object.keys(this.model).map(key => {
                return {
                    key,
                    value: this.model[key] || 'n/a',
                }
            })
        },
        notes() {
            if (!this.model) return []

            return this.model.notes
        },

        items() {
            return this.entries.map(entry => {
                const userName = entry.user.length > this.descriptionLimit ?
                    entry.user.slice(0, this.descriptionLimit) + '...' :
                    entry.user

                return Object.assign({}, entry, {
                    userName
                })
            })
        },
        date_now() {
            return new Date().toISOString()
        }
    },
    watch: {
        search() {
            // Items have already been loaded
            if (this.items.length > 0) return

            // Items have already been requested
            if (this.isLoading) return

            this.isLoading = true

            const jwt = store.getters.getJwt

            // Lazily load input items
            get_user_notes(jwt)
                .then(response => {
                    this.entries = response.data.user_notes

                })
                .catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>

<style>

</style>
